import { useMutation } from '@tanstack/react-query'
import { formatISO } from 'date-fns'
import { createView } from './requests/create'
import {
  ViewCreateParams,
  ViewRequestBody,
  ViewResponseDocument,
} from './types'

type QueryParams = {
  onMutate?: (params: ViewCreateParams) => void
  onSuccess?: (data: ViewResponseDocument, params: ViewCreateParams) => void
}

const buildRequestBody = ({
  creator,
  endDate,
  defaultTimescale,
  parentBlockId,
  startDate,
  startWeekdayIndex,
  title,
  workspaceUuid,
}: ViewCreateParams): ViewRequestBody => ({
  data: {
    type: 'view',
    attributes: {
      title: title,
      description: null,
      kind: 'plan',
      default_timescale: defaultTimescale ?? 'month',
      start_at: formatISO(startDate),
      end_at: formatISO(endDate),
      start_month_index: 0,
      start_weekday_index: startWeekdayIndex ?? 0,
    },
    relationships: {
      parent_block: parentBlockId
        ? {
            data: {
              id: parentBlockId,
              type: 'block',
            },
          }
        : undefined,
      owner: {
        data: {
          id: creator.uuid,
          type: 'user',
        },
      },
      workspace: {
        data: {
          id: workspaceUuid,
          type: 'workspace',
        },
      },
    },
  },
})

export const useCreateView = ({ onMutate, onSuccess }: QueryParams) => {
  return useMutation({
    mutationFn: (params: ViewCreateParams) => {
      return createView({
        requestBody: buildRequestBody(params),
      })
    },
    onMutate,
    onSuccess,
  })
}
